export default "__VITE_ASSET__DFDCrAPy__"